import { Form } from 'informed';
import styled, { keyframes } from 'styled-components';

import { ButtonComponent } from '@nw/design-system/omega';

export const LoginPageFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;
export const AuthFormContainer = styled(Form)`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PhoneNumberFieldContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 24px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  margin-left: 10px;
`;

export const TermsAndConditionsText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #475569;
  a {
    color: #2563eb;
    text-decoration: underline;
  }
  margin-top: ${(props) => (props.setMargin ? '12px' : '8px')};
`;
export const GetOTPText = styled.div``;
export const ErrorText = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  max-width: 420px;
  line-height: 20px;
  color: #ff0000;
  margin-top: 8px;
`;

export const SecureNoteText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: 'Inter';
  margin-top: 16px;
  margin-bottom: 4px;
  color: #475569;
  gap: 4px;
`;

const slideIn = keyframes`
  0% { opacity: 0; transform: translateX(20px); }
  100% { opacity: 1; transform: translateX(0); }
`;

export const TrustBasedStringContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #fffaf0;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 16px;
  min-height: 24px;
  overflow: hidden;
  align-self: flex-start;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: normal;
  color: #475569;
  margin-bottom: 12px;

  ${(props) =>
    props.css &&
    `
    ${props.css}
  `}
`;

export const TrustBasedMessage = styled.span`
  display: inline-block;
  animation: ${slideIn} 0.6s ease-in-out;
`;

interface AuthFormContainerButtonProps {
  isDisabled: boolean;
}

export const AuthFormContainerButton = styled(
  ButtonComponent
)<AuthFormContainerButtonProps>`
  background-color: #991b1b !important;
  color: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  opacity: ${({ isDisabled }) => (isDisabled ? '0.5' : '1')};

  @media screen and (max-width: 768px) {
    width: 100% !important;
  }
`;
